/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CompletePathwayDto } from '../models/complete-pathway-dto';
import { pathwaysControllerCreate } from '../fn/pathways/pathways-controller-create';
import { PathwaysControllerCreate$Params } from '../fn/pathways/pathways-controller-create';
import { pathwaysControllerFilter } from '../fn/pathways/pathways-controller-filter';
import { PathwaysControllerFilter$Params } from '../fn/pathways/pathways-controller-filter';
import { pathwaysControllerFindOne } from '../fn/pathways/pathways-controller-find-one';
import { PathwaysControllerFindOne$Params } from '../fn/pathways/pathways-controller-find-one';
import { pathwaysControllerGetActiveCompletePathway } from '../fn/pathways/pathways-controller-get-active-complete-pathway';
import { PathwaysControllerGetActiveCompletePathway$Params } from '../fn/pathways/pathways-controller-get-active-complete-pathway';
import { pathwaysControllerInitialize } from '../fn/pathways/pathways-controller-initialize';
import { PathwaysControllerInitialize$Params } from '../fn/pathways/pathways-controller-initialize';
import { pathwaysControllerRemove } from '../fn/pathways/pathways-controller-remove';
import { PathwaysControllerRemove$Params } from '../fn/pathways/pathways-controller-remove';
import { pathwaysControllerUpdate } from '../fn/pathways/pathways-controller-update';
import { PathwaysControllerUpdate$Params } from '../fn/pathways/pathways-controller-update';
import { ResponsePathwayDto } from '../models/response-pathway-dto';

@Injectable({ providedIn: 'root' })
export class PathwaysService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pathwaysControllerCreate()` */
  static readonly PathwaysControllerCreatePath = '/thalea-pathways/pathways';

  /**
   * Create a new pathway.
   *
   * Creates a new pathway record in the system.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerCreate$Response(params: PathwaysControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayDto>> {
    return pathwaysControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new pathway.
   *
   * Creates a new pathway record in the system.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerCreate(params: PathwaysControllerCreate$Params, context?: HttpContext): Observable<ResponsePathwayDto> {
    return this.pathwaysControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePathwayDto>): ResponsePathwayDto => r.body)
    );
  }

  /** Path part for operation `pathwaysControllerInitialize()` */
  static readonly PathwaysControllerInitializePath = '/thalea-pathways/pathways/initialize';

  /**
   * Initialize a new pathway from template.
   *
   * Creates a complete pathway with all phases, visits, and tests based on template.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerInitialize()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerInitialize$Response(params: PathwaysControllerInitialize$Params, context?: HttpContext): Observable<StrictHttpResponse<CompletePathwayDto>> {
    return pathwaysControllerInitialize(this.http, this.rootUrl, params, context);
  }

  /**
   * Initialize a new pathway from template.
   *
   * Creates a complete pathway with all phases, visits, and tests based on template.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerInitialize$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerInitialize(params: PathwaysControllerInitialize$Params, context?: HttpContext): Observable<CompletePathwayDto> {
    return this.pathwaysControllerInitialize$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompletePathwayDto>): CompletePathwayDto => r.body)
    );
  }

  /** Path part for operation `pathwaysControllerFilter()` */
  static readonly PathwaysControllerFilterPath = '/thalea-pathways/pathways/filter';

  /**
   * Filter pathways.
   *
   * Retrieves pathways based on the provided filter criteria using indexed queries.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerFilter$Response(params: PathwaysControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePathwayDto>>> {
    return pathwaysControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter pathways.
   *
   * Retrieves pathways based on the provided filter criteria using indexed queries.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerFilter(params: PathwaysControllerFilter$Params, context?: HttpContext): Observable<Array<ResponsePathwayDto>> {
    return this.pathwaysControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePathwayDto>>): Array<ResponsePathwayDto> => r.body)
    );
  }

  /** Path part for operation `pathwaysControllerGetActiveCompletePathway()` */
  static readonly PathwaysControllerGetActiveCompletePathwayPath = '/thalea-pathways/pathways/active-complete/{tenant}/{patientId}';

  /**
   * Get complete active or paused pathway for patient.
   *
   * Retrieves the active or paused pathway for a patient with all phases, visits and tests aggregated. Returns active pathway if exists, otherwise returns paused pathway.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerGetActiveCompletePathway()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwaysControllerGetActiveCompletePathway$Response(params: PathwaysControllerGetActiveCompletePathway$Params, context?: HttpContext): Observable<StrictHttpResponse<CompletePathwayDto>> {
    return pathwaysControllerGetActiveCompletePathway(this.http, this.rootUrl, params, context);
  }

  /**
   * Get complete active or paused pathway for patient.
   *
   * Retrieves the active or paused pathway for a patient with all phases, visits and tests aggregated. Returns active pathway if exists, otherwise returns paused pathway.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerGetActiveCompletePathway$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwaysControllerGetActiveCompletePathway(params: PathwaysControllerGetActiveCompletePathway$Params, context?: HttpContext): Observable<CompletePathwayDto> {
    return this.pathwaysControllerGetActiveCompletePathway$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompletePathwayDto>): CompletePathwayDto => r.body)
    );
  }

  /** Path part for operation `pathwaysControllerFindOne()` */
  static readonly PathwaysControllerFindOnePath = '/thalea-pathways/pathways/{tenant}/{createdAt}';

  /**
   * Get pathway by tenant and creation timestamp.
   *
   * Retrieves a specific pathway by its tenant and creation timestamp.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwaysControllerFindOne$Response(params: PathwaysControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayDto>> {
    return pathwaysControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get pathway by tenant and creation timestamp.
   *
   * Retrieves a specific pathway by its tenant and creation timestamp.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwaysControllerFindOne(params: PathwaysControllerFindOne$Params, context?: HttpContext): Observable<ResponsePathwayDto> {
    return this.pathwaysControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePathwayDto>): ResponsePathwayDto => r.body)
    );
  }

  /** Path part for operation `pathwaysControllerUpdate()` */
  static readonly PathwaysControllerUpdatePath = '/thalea-pathways/pathways/{tenant}/{createdAt}';

  /**
   * Update a pathway.
   *
   * Updates an existing pathway record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerUpdate$Response(params: PathwaysControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayDto>> {
    return pathwaysControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a pathway.
   *
   * Updates an existing pathway record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwaysControllerUpdate(params: PathwaysControllerUpdate$Params, context?: HttpContext): Observable<ResponsePathwayDto> {
    return this.pathwaysControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePathwayDto>): ResponsePathwayDto => r.body)
    );
  }

  /** Path part for operation `pathwaysControllerRemove()` */
  static readonly PathwaysControllerRemovePath = '/thalea-pathways/pathways/{tenant}/{createdAt}';

  /**
   * Delete a pathway.
   *
   * Deletes an existing pathway record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwaysControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwaysControllerRemove$Response(params: PathwaysControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return pathwaysControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a pathway.
   *
   * Deletes an existing pathway record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwaysControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwaysControllerRemove(params: PathwaysControllerRemove$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.pathwaysControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

}
